import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Accordion,
  Button,
  Modal,
  Spinner,
  Pagination,
  Form,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import useAuthorization from "../hooks/useAuthorization";
import RequestDetail from "../components/shared/RequestDetail";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfileAsync, selectUser } from "../features/user/userSlice";
import useMediators from "../hooks/useMediators";
import dayjs from "dayjs";
import { RequestContext } from "../contexts";
import AlertModal from "../components/shared/AlertModal";
import { useForm } from "react-hook-form";
import { fileMimeTypes } from "../assets/data/file-mimes";
import FileUpload from "../components/shared/FileUpload";
import useFileHelper from "../hooks/useFileHelper";
import DropdownInput from "../components/shared/DropdownInput";
import { ALL_ITEMS } from "../constants/all-items.constant";
import { MEDICAL_ITEMS } from "../constants/medical-items.constant";
import { USER_ROLE } from "../enums/user-role";
import { USER_ROLE_REQUESTS_PATH } from "../enums/user-role";
import { PRODUCT_ITEMS } from "../constants/products.constant";
import { createAxiosInstance } from "../utils/axios-instance";
import { useAccount, useMsal } from "@azure/msal-react";

const RequestList = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const [selectedIssueCategory, setSelectedIssueCategory] = useState(null);
  const [downloadables, setDownloadables] = useState([]);
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState(false);
  const user = useSelector(selectUser);
  const [assignToList, setAssignToList] = useState([]);
  const [currentRequestToken, setCurrentRequestToken] = useState("");
  const [getMediators] = useMediators();
  const [visibleRequests, setVisibleRequest] = useState([]);
  const [paginationItems, setPaginationItems] = useState([]);
  const [paginationSettings, setPaginationSettings] = useState({
    pageSize: 10,
    currentPage: 0,
  });
  const [conversation, setConversation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showFileUploadSuccess, setShowFileUploadSuccess] = useState(false);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});
  const [getBase64] = useFileHelper();
  const [isRetrieving, setIsRetrieving] = useState(false);
  const [currentRequestClosedDate, setCurrentRequestClosedDate] =
    useState(null);
  const [activeAccordionKey, setActiveAccordionKey] = useState("0");
  const handleReloadData = (userRole) => {
    setIsRetrieving(true);
    if (userRole) {
      setIsRetrieving(true);
      let urlPath =
        USER_ROLE_REQUESTS_PATH[userRole] ||
        USER_ROLE_REQUESTS_PATH[USER_ROLE.doctor];
      const ssoId = account?.idTokenClaims?.uid || account?.idTokenClaims?.sub;
      urlPath = `${urlPath}?ssoUserId=${ssoId}`;
      const axiosInstance = createAxiosInstance(instance);
      axiosInstance
        .get(process.env.REACT_APP_API_ENDPOINT + urlPath)
        .then((resp) => {
          const requests = resp.data;
          setAllRequests(requests);
          setIsRetrieving(false);
        });
    } else {
      setAllRequests([]);
      setIsRetrieving(false);
    }
  };
  const isDoctor = (userRole) => {
    switch (userRole) {
      case USER_ROLE.admin:
        return false;
      case USER_ROLE.mediator:
        return false;
      default:
        return true;
    }
  };
  const setAllRequests = (requests) => {
    setRequests(requests);
    setFilteredRequests(requests);
    setCurrentRequestId(requests[0]?.requestId);
    setCurrentRequestToken(requests[0]?.requestToken);
  };

  const handlePageClick = (event$) => {
    setPaginationSettings({
      currentPage: parseInt(event$.target.text) - 1,
      pageSize: paginationSettings.pageSize,
    });
  };

  const uploadMessageAttachment = (value) => {
    if (value.issueFile && value.issueFile.length > 0) {
      setIsLoading(true);
      getBase64(value.issueFile[0])
        .then((base64File) => {
          const axiosInstance = createAxiosInstance(instance);
          axiosInstance
            .post(
              process.env.REACT_APP_API_ENDPOINT + "compliance/request/upload",
              {
                fileAttachment: base64File.split(",")[1],
                fileName: value.issueFile[0].name,
                requestToken: currentRequestToken,
                createdBy: account?.idTokenClaims?.name || value.email,
              }
            )
            .then(() => {
              handleAttachmentClose();
              reset();
              setIsLoading(false);
              setShowFileUploadSuccess(true);
            })
            .catch(() => {
              handleAttachmentClose();
              setIsLoading(false);
              setShowFileUploadError(true);
            });
        })
        .catch(() => {
          setShowFileUploadError(true);
          setIsLoading(false);
        });
    }
  };

  const handleCloseSuccess = () => {
    setShowFileUploadSuccess(false);
  };

  const handleCloseError = () => {
    setShowFileUploadError(false);
  };

  const handleSelectCategory = (event) => {
    const value = event.target.value;
    setActiveAccordionKey(null);
    setSelectedIssueCategory(value);
  };

  const navigateToIssueRequest = (event) => {
    event.preventDefault();
    history.push("/issue-request");
  };

  useEffect(() => {
    if (filteredRequests) {
      var pages = Math.ceil(
        filteredRequests.length / paginationSettings.pageSize
      );
      var items = [];
      for (var i = 0; i < pages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            onClick={handlePageClick}
            active={i === paginationSettings.currentPage}
          >
            {i + 1}
          </Pagination.Item>
        );
      }
      setPaginationItems(items);
      setVisibleRequest(
        filteredRequests.slice(
          paginationSettings.currentPage * paginationSettings.pageSize,
          paginationSettings.currentPage * paginationSettings.pageSize +
            paginationSettings.pageSize
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredRequests, paginationSettings]);
  useEffect(() => {
    handleReloadData(user?.userRole);
    setAssignToList(getMediators());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  useEffect(() => {
    if (currentRequestId && showAttachments) {
      const axiosInstance = createAxiosInstance(instance);
      setIsAttachmentsLoading(true);
      axiosInstance
        .get(
          process.env.REACT_APP_API_ENDPOINT +
            "compliance/request/files/" +
            currentRequestToken
        )
        .then((resp) => {
          setDownloadables(resp.data);
        })
        .finally(() => setIsAttachmentsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRequestId, showAttachments]);

  useEffect(() => {
    if (currentRequestToken) {
      axios.get(`${process.env.REACT_APP_API_ENDPOINT}compliance/request/inbox/${currentRequestToken}`);
    }
  }, [currentRequestToken, account]);

  useEffect(() => {
    if (selectedIssueCategory) {
      const _filteredRequests = requests.filter(
        (request) => request.issueCategory === selectedIssueCategory
      );
      setFilteredRequests(_filteredRequests);
    } else {
      setFilteredRequests(requests);
    }
  }, [selectedIssueCategory, setFilteredRequests, requests]);

  const handleOpenAttachments = () => {
    // setCurrentRequestId(requestId);
    setShowAttachments(true);
  };

  const handleAttachmentClose = () => {
    // setCurrentRequestId(null);
    setShowAttachments(false);
  };

  const onToggleAccordionItem = (idx) => {
    if (idx !== null) {
      const currentRequestId = requests[+idx]?.requestId;
      const currentRequestToken = requests[+idx]?.requestToken;
      setActiveAccordionKey(idx.toString());
      setCurrentRequestClosedDate(requests[+idx].closedDate);
      setCurrentRequestId(currentRequestId);
      setCurrentRequestToken(currentRequestToken);
    } else {
      setActiveAccordionKey(null);
    }
  };
  const handleDownload = (downloadable) => {
    const axiosInstance = createAxiosInstance(instance);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}compliance/request/file/${downloadable.requestFileId}`
      )
      .then((resp) => {
        const fileType = downloadable.fileName
          .split(".")
          [downloadable.fileName.split(".").length - 1].toLowerCase();
        const mimeType = fileMimeTypes[fileType];
        downloadBase64File(
          resp.data.fileAttachment,
          downloadable.fileName,
          mimeType
        );
      });
  };

  const downloadBase64File = (contentBase64, fileName, mimeType) => {
    const linkSource = `data:${mimeType};base64,${contentBase64}`;
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);

    downloadLink.href = linkSource;
    downloadLink.target = "_self";
    downloadLink.download = fileName;
    downloadLink.click();
  };

  return (
    <Container fluid className="mt-20">
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h2>Issues or Requests Submitted</h2>
            </Card.Header>

            <Card.Body>
              {isRetrieving ? (
                <>
                  <Spinner animation="border" role="status" size="sm">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </>
              ) : (
                <>
                  {!isDoctor(user?.userRole) && (
                    <Row>
                      <Col sm={6}></Col>
                      <Col sm={6}>
                        <Form.Group>
                          <Form.Label>Filter by Issue Category</Form.Label>
                          <Form.Select
                            value={selectedIssueCategory || ""}
                            aria-label="Default select example"
                            onChange={handleSelectCategory}
                          >
                              {ALL_ITEMS.map((item, i) => (
                                  <option key={i} value={item.value.split("/")[0]}>
                                      {item.label}
                                  </option>
                              ))}
                            {/*{MEDICAL_ITEMS.map((item, i) => (*/}
                            {/*  <option key={i} value={item.value.split("/")[0]}>*/}
                            {/*    {item.label}*/}
                            {/*  </option>*/}
                            {/*))}*/}
                            {/*{PRODUCT_ITEMS.map((item, i) => (*/}
                            {/*  <option key={i} value={item.value.split("/")[0]}>*/}
                            {/*    {item.label}*/}
                            {/*  </option>*/}
                            {/*))}*/}
                          </Form.Select>
                        </Form.Group>
                        <Button
                          className="float-end mt-2"
                          size={"xs"}
                          onClick={() => setSelectedIssueCategory(null)}
                        >
                          Reset Filter
                        </Button>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col sm={12}>
                      <Pagination>{paginationItems}</Pagination>
                    </Col>
                  </Row>

                  <Accordion
                    activeKey={activeAccordionKey}
                    onSelect={onToggleAccordionItem}
                    defaultActiveKey="0"
                  >
                    {visibleRequests && visibleRequests.length > 0 ? (
                      visibleRequests.map((request, i) => (
                        <Accordion.Item eventKey={i.toString()} key={i}>
                          <Accordion.Header>
                            <h1>
                              Date Created:{" "}
                              {dayjs(request.createdDate).format("MM-DD-YYYY")}
                            </h1>
                          </Accordion.Header>
                          <Accordion.Body>
                             <RequestDetail
                                handleReload={() =>
                                  handleReloadData(user?.userRole)
                                }
                                key={i}
                                request={request}
                                items={assignToList}
                                handleOpenAttachments={handleOpenAttachments}
                              ></RequestDetail>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))
                    ) : (
                      <>
                        No Issues found, please click{" "}
                        <a onClick={navigateToIssueRequest} href="#">
                          here
                        </a>{" "}
                        to submit a request
                      </>
                    )}
                  </Accordion>
                  <Row className="mt-10">
                    <Col>
                      <Pagination>{paginationItems}</Pagination>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal size={"lg"} show={showAttachments} onHide={handleAttachmentClose}>
        <Modal.Header closeButton>
          <Modal.Title>Attachments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isAttachmentsLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 80 }}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : downloadables && downloadables.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Filename</th>
                  <th>Size</th>
                  <th>Date Created</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {downloadables &&
                  downloadables.map((downloadable, i) => (
                    <tr key={i}>
                      <th>{downloadable.fileName}</th>
                      <th>{downloadable.fileSize}</th>
                      <th>
                        {dayjs(downloadable.createdDate).format("MM-DD-YYYY")}
                      </th>
                      <th>
                        <Button
                          size={"xs"}
                          variant={"link"}
                          onClick={() => handleDownload(downloadable)}
                          href="#"
                        >
                          Click to download
                        </Button>
                      </th>
                    </tr>
                  ))}
              </tbody>
            </Table>
          ) : (
            <h4>There are no available data</h4>
          )}

          {!currentRequestClosedDate && (
            <form onSubmit={handleSubmit(uploadMessageAttachment)}>
              <FileUpload register={register} errors={errors} />
              <Button
                disabled={isLoading}
                className="float-end btn-fill"
                type="submit"
                variant="primary"
              >
                Upload
                {isLoading && (
                  <Spinner animation="border" role="status" size="sm">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                )}
              </Button>
            </form>
          )}
        </Modal.Body>
      </Modal>

      <AlertModal
        show={showFileUploadSuccess}
        handleClose={handleCloseSuccess}
        modalTitle={"Upload Attachment Success"}
        modalBody={"You have successfully uploaded the files"}
        handleConfirmButton={handleCloseSuccess}
        confirmButton={"Close"}
      ></AlertModal>

      <AlertModal
        show={showFileUploadError}
        handleClose={handleCloseError}
        modalTitle={"Upload Attachment Error"}
        modalBody={
          "There was a problem uploading files. Please try again later."
        }
        handleConfirmButton={handleCloseError}
        confirmButton={"Close"}
      ></AlertModal>
    </Container>
  );
};

export default RequestList;
